import { ReactElement } from "react";
import Create from "@shared/FormTemplates/Create";
import CreateForm from "./CreateForm";
import createItemAPI from "@services/Clients/WhaleShark/vaultCarousel/createItem";
import validator from "@validators/Clients/WhaleShark/vaultCarousel/vault.validate";
import formMapper from "@mappers/Clients/WhaleShark/vaultCarousel/VaultItem.mapper";

const CreateItem = (): ReactElement => (
  <Create
    CustomForm={CreateForm}
    createHook={createItemAPI}
    validator={validator}
    formMapper={formMapper}
  />
);

export default CreateItem;
